import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { ToastrModule } from 'ngx-toastr';
import { MaterialModule } from '../material.module';
import { DformDialogModule } from './components/dform-dialogs/dialog.module';
import { DformPaginationPlusModule } from './components/dform-pagination-plus/dform-pagination-plus.module';
import { ErrorCodeComponent } from './components/error-code/error-code.component';
import { ArrayFormComponent } from './components/form/array-form.component';
import { DynamicFormHorizontalComponent } from './components/form/dynamic-form-horizontal/dynamic-form-horizontal.component';
import { DynamicFormVerticalComponent } from './components/form/dynamic-form-vertical/dynamic-form-vertical.component';
import { DynamicFormComponent } from './components/form/dynamic-form.component';
import { FormAutoCompleteComponent } from './components/form/form-auto-complete/form-auto-complete.component';
import { FormGroupCheckboxComponent } from './components/form/form-group-checkbox/form-group-checkbox.component';
import { FormGroupDateComponent } from './components/form/form-group-date/form-group-date.component';
import { FormGroupRadioComponent } from './components/form/form-group-radio/form-group-radio.component';
import { FormGroupSelectComponent } from './components/form/form-group-select/form-group-select.component';
import { FormGroupSlideToggleComponent } from './components/form/form-group-slide-toggle/form-group-slide-toggle.component';
import { FormGroupTextComponent } from './components/form/form-group-text/form-group-text.component';
import { FormGroupTextareaComponent } from './components/form/form-group-textarea/form-group-textarea.component';
import { FormNgSelectComponent } from './components/form/form-ng-select/form-ng-select.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { SearchInputComponent } from './components/search/search-input/search-input.component';
import { SearchProcessComponent } from './components/search/search-process/search-process.component';
import { SearchServiceComponent } from './components/search/search-service/search-service.component';
import { TreeMenuComponent } from './components/tree-menu/tree-menu.component';
import { AccordionTreeDirective } from './directives/accordion-tree.directive';
import { AccordionAnchorTreeDirective } from './directives/accordionanchor-tree.directive';
import { AccordionItemTreeDirective } from './directives/accordionItem-tree.directive';
import { DisableControlDirective } from './directives/disable-control.directive';
import { FormItemDirective } from './directives/form-item.directive';
import { NonVietNameseSpaceDirective } from './directives/non-vietnamese-space.directive';
import { NonVietNameseDirective } from './directives/non-vietnamese.directive';
import { AmountByWords } from './pipes/amount-by-words.pipe';
import { ChangeDatePipe } from './pipes/change-date.pipe';
import { ChangeRMPipe } from './pipes/change-rm.pipe';
import { ChangeSitePipe } from './pipes/change-site.pipe';
import { CurrencyMaskPipe } from './pipes/currency-mask.pipe';
import { GroupByPipe } from './pipes/group-by.pipe';
import { MbbCurrencyPipe } from './pipes/mbb-currency.pipe';
import { MbbLoyaltyPipe } from './pipes/mbb-loyalty.pipe';
import { MbbPeriodPipe } from './pipes/mbb-period.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { FooterComponent } from './public-screen/footer/footer.component';
import { LoaderActionComponent } from './public-screen/loader-action/loader-action.component';
import { MenuTreeComponent } from './public-screen/menu-tree/menu-tree.component';
import { MockDataComponent } from './public-screen/mock-data/mock-data.component';
import { ItemControlService } from './services/item-control.service';
import {NoDataComponent} from "@shared/public-screen/no-data/no-data.component";

const THIRD_MODULES = [
  MaterialModule,
  FlexLayoutModule,
  NgProgressModule,
  NgProgressRouterModule,
  NgProgressHttpModule,
  NgSelectModule,
  ToastrModule,
  TranslateModule,
  DformPaginationPlusModule
];
const COMPONENTS = [
  PageHeaderComponent,
  DynamicFormComponent,
  DynamicFormHorizontalComponent,
  DynamicFormVerticalComponent,
  FormGroupTextComponent,
  FormGroupCheckboxComponent,
  FormGroupSelectComponent,
  FormGroupDateComponent,
  FormGroupTextareaComponent,
  FormGroupRadioComponent,
  FormNgSelectComponent,
  FormGroupSlideToggleComponent,
  SearchProcessComponent,
  ErrorCodeComponent,
  TreeMenuComponent,
  SearchServiceComponent,
  SearchInputComponent,
  ArrayFormComponent,
  FooterComponent,
  FormAutoCompleteComponent,
  LoaderActionComponent,
  MockDataComponent,
  MenuTreeComponent,
  NoDataComponent
];
const COMPONENTS_DYNAMIC = [];
const DIRECTIVES = [DisableControlDirective, FormItemDirective, AccordionItemTreeDirective, AccordionAnchorTreeDirective, AccordionTreeDirective, NonVietNameseDirective, NonVietNameseSpaceDirective];
const PIPES = [SafeUrlPipe, AmountByWords, CurrencyMaskPipe, GroupByPipe, MbbPeriodPipe, MbbCurrencyPipe, ChangeSitePipe, ChangeRMPipe, ChangeDatePipe, MbbLoyaltyPipe];

@NgModule({
  declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC, ...DIRECTIVES, ...PIPES],
  imports: [CommonModule, FormsModule, RouterModule, ReactiveFormsModule, ...THIRD_MODULES],
  exports: [
    CommonModule,
    DformDialogModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    ...THIRD_MODULES,
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
  ],
  providers: [ItemControlService, ChangeSitePipe, ChangeRMPipe, ChangeDatePipe, MbbLoyaltyPipe],
  entryComponents: COMPONENTS_DYNAMIC,
})
export class SharedModule { }
